export const HERO_SLIDES = [
  {
    title: "ART-DECO",
    description: "Вневременная элегантность с пропорциями ар-деко",
    image: "/images/home/hero/slide-1.jpg",
    id: 1,
  },
  {
    title: "ART-DECO",
    description: "Современная геометрия и часовое мастерство",
    image: "/images/home/hero/slide-2.jpg",
    id: 2,
  },
];

export const HERITAGE_SLIDES = [
  { desktop: "/images/home/heritage/slide-1.png", mobile: "/images/home/heritage/slide-1-mobile.png" },
  { desktop: "/images/home/heritage/slide-2.png", mobile: "/images/home/heritage/slide-1-mobile.png" },
];
